import { FleekError } from './FleekError';

type GitIntegrationNotFoundErrorOptions = { id: string } | { siteId: string };

export class GitIntegrationNotFoundError extends FleekError<GitIntegrationNotFoundErrorOptions> {
  public name = 'GitIntegrationNotFoundError';

  toString = () => {
    let infix = '';

    if ('siteId' in this.data) {
      infix = `for site ${this.data.siteId}`;
    } else if ('id' in this.data) {
      infix = `with id ${this.data.id}`;
    }

    return `Git Integration ${infix} not found`;
  };
}
